// Firmenkonto (Kundenkonto → Firma): Umschalter, Mitarbeiter, Limits, Freigaben, Checkout auf Rechnung. Flache Schlüssel cc_*, wird in fieldMapping.js eingemischt.
const de = {
  vehicleSearchPlaceholder: "Suchen: Kennzeichen, Marke, Modell …",
  gst_title: "Gast / Fahrgast",
  gst_desc: "Fährt jemand anderes mit? Dann hier die Daten des Gastes angeben.",
  gst_toggle: "Ich buche für einen Gast (andere Person)",
  gst_hint: "Der Fahrer kontaktiert den Gast unter diesen Daten. Die Buchung bleibt in Ihrem Konto und wird über Sie abgerechnet.",
  gst_optional: "optional",
  gst_required: "Pflichtfeld",
  gst_invalid: "ungültig",
  gst_email_hint: "Mit E-Mail-Adresse erhält der Gast eine Kopie der Buchungsbestätigung.",
  gst_missing: "Angaben zum Gast fehlen",
  cc_pending_company_note: "Nach der Bestätigung wird dein Firmenantrag für „{name}“ automatisch gestellt.",
  invoice: "Auf Rechnung (nichts kassieren)",
  cc_account_type: "Kontoart",
  cc_private_person: "Privatperson",
  cc_company: "Firma",
  cc_private: "Privat",
  cc_switch: "Konto wechseln",
  cc_pending: "wird geprüft",
  cc_blocked: "gesperrt",
  cc_pending_hint: "Diese Firma wird noch von GoTransfer24 geprüft.",
  cc_blocked_hint: "Diese Firma ist gesperrt.",
  cc_register_company_hint: "Du registrierst dich als Ansprechperson der Firma. Nach der E-Mail-Bestätigung stellst du mit einem Klick den Firmenantrag; GoTransfer24 prüft ihn und schaltet das Firmenkonto frei (bis dahin 0 % Rabatt).",
  cc_company_name: "Firmenname",
  cc_vat_id: "USt-IdNr. (optional)",
  cc_apply_open: "Firma beantragen",
  cc_apply_title: "Firmenkonto beantragen",
  cc_apply_text: "GoTransfer24 prüft den Antrag und schaltet die Firma frei. Danach kannst du Mitarbeiter einladen. Buchungen laufen auf Rechnung.",
  cc_apply_send: "Antrag senden",
  cc_apply_done: "Antrag gesendet. Du bekommst eine E-Mail, sobald die Firma freigeschaltet ist.",
  cc_contact_title: "Kontaktperson der Firma",
  cc_contact_hint: "Mitarbeiter sehen diese Person, wenn ihr Limit nicht reicht, und können sich dort melden.",
  cc_no_limit: "Kein Limit",
  cc_admin_unlimited: "Als Admin buchst du ohne Limit.",
  cc_my_limit: "Mein Jahreslimit",
  cc_used: "Verbraucht",
  cc_remaining: "Noch verfügbar",
  cc_limit_year: "Jahreslimit",
  cc_limit_year_eur: "Jahreslimit in €",
  cc_unlimited: "unbegrenzt",
  cc_member_blocked: "Deine Buchungen für diese Firma wurden gesperrt.",
  cc_limit_contact: "Bei Fragen oder für eine Erhöhung",
  cc_limit_contact_ask: "Bitte wende dich an",
  cc_discount: "Firmenrabatt",
  cc_term: "Zahlungsziel",
  cc_days: "Tage",
  cc_my_role: "Meine Rolle",
  cc_role: "Rolle",
  cc_role_admin: "Admin",
  cc_role_member: "Mitarbeiter",
  cc_invoice_only: "Buchungen als Firma laufen auf Rechnung – keine Zahlung an den Fahrer.",
  cc_privacy_hint: "Datenschutz-Hinweis: Der Admin deiner Firma sieht alle Buchungen, die du über die Firma machst (Strecke, Zeit, Preis, Fahrgast).",
  cc_tab_overview: "Übersicht",
  cc_tab_bookings: "Buchungen",
  cc_tab_members: "Mitarbeiter",
  cc_tab_addresses: "Adressen",
  cc_tab_approvals: "Freigaben",
  cc_cost_center: "Kostenstelle",
  cc_optional: "optional",
  cc_cost_center_pick: "Kostenstelle wählen",
  cc_cost_center_ph: "z. B. Vertrieb oder Projekt 4711",
  cc_cost_center_hint: "Erscheint auf der Sammelrechnung und in der Monatsübersicht Ihrer Firma.",
  cc_cost_centers_title: "Kostenstellen",
  cc_cost_centers_hint: "Eine Kostenstelle pro Zeile. Mitarbeitende wählen sie bei der Buchung aus; Rechnung und Monatsübersicht werden danach gegliedert. Ohne Liste können sie frei eingetragen werden.",
  cc_cost_centers_ph: "Vertrieb\\nGeschäftsführung\\nProjekt 4711",
  cc_cost_center_required: "Kostenstelle bei jeder Buchung verlangen",
  cc_tab_invoices: "Rechnungen",
  cc_summary_title: "Monatsübersicht",
  cc_summary_hint: "Alle Fahrten eines Monats nach Kostenstelle gegliedert – als PDF zum Prüfen und Weitergeben.",
  cc_summary_show: "Übersicht anzeigen",
  cc_month: "Monat",
  cc_no_trips_month: "In diesem Monat gibt es keine abgeschlossenen Fahrten.",
  cc_no_invoices: "Noch keine Rechnungen.",
  cc_inv_open: "offen",
  cc_inv_paid: "bezahlt",
  cc_due: "fällig bis",
  cc_download: "Herunterladen",
  cc_close: "Schließen",
  cc_tab_settings: "Kontakt & Kostenstellen",
  cc_bookings_all: "Alle Buchungen der Firma.",
  cc_bookings_own: "Deine Buchungen für diese Firma.",
  cc_paid: "bezahlt",
  cc_on_invoice: "Auf Rechnung",
  cc_passenger: "Fahrgast",
  cc_booked_by: "gebucht von",
  cc_invite_title: "Mitarbeiter einladen",
  cc_invite_send: "Einladung senden",
  cc_invited: "Einladung gesendet.",
  cc_open_invites: "Offene Einladungen",
  cc_revoke: "Zurückziehen",
  cc_invite_revoked: "Einladung zurückgezogen.",
  cc_you: "du",
  cc_save_limit: "Limit speichern",
  cc_saved: "Gespeichert.",
  cc_block_booking: "Buchen sperren",
  cc_blocked_set: "Buchen gesperrt.",
  cc_blocked_unset: "Buchen wieder erlaubt.",
  cc_remove: "Entfernen",
  cc_remove_q: "Mitarbeiter entfernen?",
  cc_remove_text: "kann dann nicht mehr für die Firma buchen.",
  cc_removed: "Mitarbeiter entfernt.",
  cc_approvals_hint: "Mitarbeiter, deren Limit nicht reicht, können eine Freigabe anfragen. Eine erteilte Freigabe gilt 14 Tage für genau diese Buchung.",
  cc_no_approvals: "Keine Freigabe-Anfragen.",
  cc_decision_note: "Hinweis (optional)",
  cc_approve: "Freigeben",
  cc_reject: "Ablehnen",
  cc_approved_done: "Freigabe erteilt.",
  cc_rejected_done: "Anfrage abgelehnt.",
  cc_ap_open: "offen",
  cc_ap_approved: "freigegeben",
  cc_ap_rejected: "abgelehnt",
  cc_ap_used: "verwendet",
  cc_ap_expired: "abgelaufen",
  cc_valid_until: "gültig bis",
  cc_invite_off: "Diese Funktion ist aktuell nicht verfügbar.",
  cc_invite_page_title: "Einladung zur Firma",
  cc_invite_page_text: "Du wurdest eingeladen, Transfers zu buchen für",
  cc_invite_for: "Einladung für",
  cc_invite_accept: "Einladung annehmen",
  cc_invite_wrong: "Du bist mit einer anderen Adresse angemeldet. Die Einladung gilt für",
  cc_invite_no_account: "Noch kein Konto? Konto erstellen",
  cc_invite_have_account: "Schon ein Konto? Anmelden",
  cc_booking_for: "Buchung für",
  cc_booking_for_desc: "Auf Rechnung – du buchst als Mitarbeiter/Admin der Firma.",
  cc_limit_left: "Noch verfügbar im Jahreslimit",
  cc_passenger_hint: "Fährt jemand anderes mit (z. B. ein Gast)? Dann hier den Fahrgast eintragen – der Fahrer kontaktiert diese Person.",
  cc_passenger_name: "Name des Fahrgasts (optional)",
  cc_passenger_phone: "Telefon des Fahrgasts",
  cc_pick_billing: "Rechnungsadresse",
  cc_pick_billing_desc: "Wähle die Firmenadresse für die Rechnung.",
  cc_payment_title: "Zahlung",
  cc_invoice_terms: "Zahlungsziel",
  cc_approved_banner: "Eine Freigabe deiner Firma liegt vor.",
  cc_limit_exceeded: "Dein Jahreslimit wäre mit dieser Buchung überschritten.",
  cc_this_booking: "Diese Buchung",
  cc_approval_alt: "Alternativ kannst du eine Freigabe bei den Admins deiner Firma anfragen:",
  cc_approval_note: "Hinweis für die Admins (optional)",
  cc_approval_request: "Freigabe anfragen",
  cc_approval_sent: "Anfrage gesendet. Nach der Freigabe bekommst du eine E-Mail und kannst die Buchung abschließen.",
  cc_book_invoice: "Verbindlich auf Rechnung buchen",
};
const en = {
  vehicleSearchPlaceholder: "Search: license plate, brand, model …",
  gst_title: "Guest / passenger",
  gst_desc: "Is someone else travelling? Enter the guest’s details here.",
  gst_toggle: "I am booking for a guest (another person)",
  gst_hint: "The driver contacts the guest using these details. The booking stays in your account and is billed through you.",
  gst_optional: "optional",
  gst_required: "Required",
  gst_invalid: "invalid",
  gst_email_hint: "With an e-mail address the guest receives a copy of the booking confirmation.",
  gst_missing: "Guest details are missing",
  cc_pending_company_note: "After confirmation your company application for “{name}” is submitted automatically.",
  invoice: "On invoice (do not collect)",
  cc_account_type: "Account type",
  cc_private_person: "Private person",
  cc_company: "Company",
  cc_private: "Private",
  cc_switch: "Switch account",
  cc_pending: "under review",
  cc_blocked: "blocked",
  cc_pending_hint: "GoTransfer24 is still reviewing this company.",
  cc_blocked_hint: "This company is blocked.",
  cc_register_company_hint: "You register as the company contact. After confirming your e-mail you submit the company application with one click; GoTransfer24 reviews it and activates the company account (0 % discount until then).",
  cc_company_name: "Company name",
  cc_vat_id: "VAT ID (optional)",
  cc_apply_open: "Apply for a company account",
  cc_apply_title: "Apply for a company account",
  cc_apply_text: "GoTransfer24 reviews the application and activates the company. Afterwards you can invite employees. Bookings are invoiced.",
  cc_apply_send: "Submit application",
  cc_apply_done: "Application sent. You will get an e-mail once the company is activated.",
  cc_contact_title: "Company contact person",
  cc_contact_hint: "Employees see this person when their limit is not enough and can get in touch.",
  cc_no_limit: "No limit",
  cc_admin_unlimited: "As an admin you book without a limit.",
  cc_my_limit: "My annual limit",
  cc_used: "Used",
  cc_remaining: "Remaining",
  cc_limit_year: "Annual limit",
  cc_limit_year_eur: "Annual limit in €",
  cc_unlimited: "unlimited",
  cc_member_blocked: "Your bookings for this company have been blocked.",
  cc_limit_contact: "For questions or an increase",
  cc_limit_contact_ask: "Please contact",
  cc_discount: "Company discount",
  cc_term: "Payment term",
  cc_days: "days",
  cc_my_role: "My role",
  cc_role: "Role",
  cc_role_admin: "Admin",
  cc_role_member: "Employee",
  cc_invoice_only: "Company bookings are invoiced – no payment to the driver.",
  cc_privacy_hint: "Privacy notice: your company admin can see all bookings you make through the company (route, time, price, passenger).",
  cc_tab_overview: "Overview",
  cc_tab_bookings: "Bookings",
  cc_tab_members: "Employees",
  cc_tab_addresses: "Addresses",
  cc_tab_approvals: "Approvals",
  cc_cost_center: "Cost center",
  cc_optional: "optional",
  cc_cost_center_pick: "Choose cost center",
  cc_cost_center_ph: "e.g. Sales or project 4711",
  cc_cost_center_hint: "Appears on your company's collective invoice and monthly summary.",
  cc_cost_centers_title: "Cost centers",
  cc_cost_centers_hint: "One cost center per line. Employees choose it when booking; the invoice and monthly summary are grouped by it. Without a list it can be typed freely.",
  cc_cost_centers_ph: "Sales\\nManagement\\nProject 4711",
  cc_cost_center_required: "Require a cost center for every booking",
  cc_tab_invoices: "Invoices",
  cc_summary_title: "Monthly summary",
  cc_summary_hint: "All trips of a month grouped by cost center – as a PDF to check and forward.",
  cc_summary_show: "Show summary",
  cc_month: "Month",
  cc_no_trips_month: "There are no completed trips in this month.",
  cc_no_invoices: "No invoices yet.",
  cc_inv_open: "open",
  cc_inv_paid: "paid",
  cc_due: "due",
  cc_download: "Download",
  cc_close: "Close",
  cc_tab_settings: "Contact & cost centers",
  cc_bookings_all: "All bookings of the company.",
  cc_bookings_own: "Your bookings for this company.",
  cc_paid: "paid",
  cc_on_invoice: "On invoice",
  cc_passenger: "Passenger",
  cc_booked_by: "booked by",
  cc_invite_title: "Invite an employee",
  cc_invite_send: "Send invitation",
  cc_invited: "Invitation sent.",
  cc_open_invites: "Open invitations",
  cc_revoke: "Revoke",
  cc_invite_revoked: "Invitation revoked.",
  cc_you: "you",
  cc_save_limit: "Save limit",
  cc_saved: "Saved.",
  cc_block_booking: "Block booking",
  cc_blocked_set: "Booking blocked.",
  cc_blocked_unset: "Booking allowed again.",
  cc_remove: "Remove",
  cc_remove_q: "Remove employee?",
  cc_remove_text: "can then no longer book for the company.",
  cc_removed: "Employee removed.",
  cc_approvals_hint: "Employees whose limit is not enough can request approval. A granted approval is valid for 14 days for exactly this booking.",
  cc_no_approvals: "No approval requests.",
  cc_decision_note: "Note (optional)",
  cc_approve: "Approve",
  cc_reject: "Reject",
  cc_approved_done: "Approval granted.",
  cc_rejected_done: "Request rejected.",
  cc_ap_open: "open",
  cc_ap_approved: "approved",
  cc_ap_rejected: "rejected",
  cc_ap_used: "used",
  cc_ap_expired: "expired",
  cc_valid_until: "valid until",
  cc_invite_off: "This feature is currently unavailable.",
  cc_invite_page_title: "Company invitation",
  cc_invite_page_text: "You have been invited to book transfers for",
  cc_invite_for: "Invitation for",
  cc_invite_accept: "Accept invitation",
  cc_invite_wrong: "You are signed in with a different address. The invitation is for",
  cc_invite_no_account: "No account yet? Create one",
  cc_invite_have_account: "Already have an account? Sign in",
  cc_booking_for: "Booking for",
  cc_booking_for_desc: "On invoice – you book as employee/admin of the company.",
  cc_limit_left: "Remaining in annual limit",
  cc_passenger_hint: "Is someone else travelling (e.g. a guest)? Enter the passenger here – the driver will contact this person.",
  cc_passenger_name: "Passenger name (optional)",
  cc_passenger_phone: "Passenger phone",
  cc_pick_billing: "Billing address",
  cc_pick_billing_desc: "Choose the company address for the invoice.",
  cc_payment_title: "Payment",
  cc_invoice_terms: "Payment term",
  cc_approved_banner: "Your company has approved this booking.",
  cc_limit_exceeded: "Your annual limit would be exceeded by this booking.",
  cc_this_booking: "This booking",
  cc_approval_alt: "Alternatively you can ask your company admins for approval:",
  cc_approval_note: "Note for the admins (optional)",
  cc_approval_request: "Request approval",
  cc_approval_sent: "Request sent. After approval you will get an e-mail and can complete the booking.",
  cc_book_invoice: "Book on invoice",
};
const tr = {
  vehicleSearchPlaceholder: "Ara: plaka, marka, model …",
  gst_title: "Misafir / yolcu",
  gst_desc: "Başka biri mi yolculuk edecek? Misafir bilgilerini buraya girin.",
  gst_toggle: "Bir misafir (başka biri) için rezervasyon yapıyorum",
  gst_hint: "Sürücü misafirle bu bilgilerle iletişime geçer. Rezervasyon hesabınızda kalır ve sizin üzerinizden faturalanır.",
  gst_optional: "isteğe bağlı",
  gst_required: "Zorunlu",
  gst_invalid: "geçersiz",
  gst_email_hint: "E-posta adresiyle misafir rezervasyon onayının bir kopyasını alır.",
  gst_missing: "Misafir bilgileri eksik",
  cc_pending_company_note: "Onaydan sonra “{name}” için şirket başvurunuz otomatik olarak gönderilir.",
  invoice: "Faturalı (tahsilat yok)",
  cc_account_type: "Hesap türü",
  cc_private_person: "Bireysel",
  cc_company: "Şirket",
  cc_private: "Bireysel",
  cc_switch: "Hesap değiştir",
  cc_pending: "inceleniyor",
  cc_blocked: "engellendi",
  cc_pending_hint: "Bu şirket GoTransfer24 tarafından hâlâ inceleniyor.",
  cc_blocked_hint: "Bu şirket engellenmiş.",
  cc_register_company_hint: "Şirketin yetkilisi olarak kayıt oluyorsunuz. E-postayı onayladıktan sonra tek tıkla şirket başvurusunu gönderirsiniz; GoTransfer24 inceler ve hesabı etkinleştirir (o zamana kadar %0 indirim).",
  cc_company_name: "Şirket adı",
  cc_vat_id: "KDV kimlik no. (isteğe bağlı)",
  cc_apply_open: "Şirket hesabı başvurusu",
  cc_apply_title: "Şirket hesabı başvurusu",
  cc_apply_text: "GoTransfer24 başvuruyu inceler ve şirketi etkinleştirir. Ardından çalışanları davet edebilirsiniz. Rezervasyonlar faturalandırılır.",
  cc_apply_send: "Başvuruyu gönder",
  cc_apply_done: "Başvuru gönderildi. Şirket etkinleştirildiğinde e-posta alacaksınız.",
  cc_contact_title: "Şirket irtibat kişisi",
  cc_contact_hint: "Çalışanlar limitleri yetmediğinde bu kişiyi görür ve iletişime geçebilir.",
  cc_no_limit: "Limit yok",
  cc_admin_unlimited: "Yönetici olarak limitsiz rezervasyon yaparsınız.",
  cc_my_limit: "Yıllık limitim",
  cc_used: "Kullanılan",
  cc_remaining: "Kalan",
  cc_limit_year: "Yıllık limit",
  cc_limit_year_eur: "Yıllık limit (€)",
  cc_unlimited: "sınırsız",
  cc_member_blocked: "Bu şirket için rezervasyonlarınız engellendi.",
  cc_limit_contact: "Sorular veya artırım için",
  cc_limit_contact_ask: "Lütfen iletişime geçin:",
  cc_discount: "Şirket indirimi",
  cc_term: "Ödeme vadesi",
  cc_days: "gün",
  cc_my_role: "Rolüm",
  cc_role: "Rol",
  cc_role_admin: "Yönetici",
  cc_role_member: "Çalışan",
  cc_invoice_only: "Şirket rezervasyonları faturalandırılır – sürücüye ödeme yapılmaz.",
  cc_privacy_hint: "Gizlilik notu: Şirket yöneticiniz şirket üzerinden yaptığınız tüm rezervasyonları görebilir (güzergâh, zaman, fiyat, yolcu).",
  cc_tab_overview: "Genel bakış",
  cc_tab_bookings: "Rezervasyonlar",
  cc_tab_members: "Çalışanlar",
  cc_tab_addresses: "Adresler",
  cc_tab_approvals: "Onaylar",
  cc_cost_center: "Masraf merkezi",
  cc_optional: "isteğe bağlı",
  cc_cost_center_pick: "Masraf merkezi seçin",
  cc_cost_center_ph: "örn. Satış veya proje 4711",
  cc_cost_center_hint: "Şirketinizin toplu faturasında ve aylık özetinde yer alır.",
  cc_cost_centers_title: "Masraf merkezleri",
  cc_cost_centers_hint: "Satır başına bir masraf merkezi. Çalışanlar rezervasyonda seçer; fatura ve aylık özet buna göre gruplanır. Liste yoksa serbestçe yazılabilir.",
  cc_cost_centers_ph: "Satış\\nYönetim\\nProje 4711",
  cc_cost_center_required: "Her rezervasyonda masraf merkezi iste",
  cc_tab_invoices: "Faturalar",
  cc_summary_title: "Aylık özet",
  cc_summary_hint: "Bir ayın tüm yolculukları masraf merkezine göre gruplanmış – kontrol ve iletmek için PDF.",
  cc_summary_show: "Özeti göster",
  cc_month: "Ay",
  cc_no_trips_month: "Bu ayda tamamlanmış yolculuk yok.",
  cc_no_invoices: "Henüz fatura yok.",
  cc_inv_open: "açık",
  cc_inv_paid: "ödendi",
  cc_due: "vade",
  cc_download: "İndir",
  cc_close: "Kapat",
  cc_tab_settings: "İletişim ve masraf merkezleri",
  cc_bookings_all: "Şirketin tüm rezervasyonları.",
  cc_bookings_own: "Bu şirket için rezervasyonlarınız.",
  cc_paid: "ödendi",
  cc_on_invoice: "Faturalı",
  cc_passenger: "Yolcu",
  cc_booked_by: "rezerve eden",
  cc_invite_title: "Çalışan davet et",
  cc_invite_send: "Daveti gönder",
  cc_invited: "Davet gönderildi.",
  cc_open_invites: "Bekleyen davetler",
  cc_revoke: "Geri çek",
  cc_invite_revoked: "Davet geri çekildi.",
  cc_you: "siz",
  cc_save_limit: "Limiti kaydet",
  cc_saved: "Kaydedildi.",
  cc_block_booking: "Rezervasyonu engelle",
  cc_blocked_set: "Rezervasyon engellendi.",
  cc_blocked_unset: "Rezervasyona tekrar izin verildi.",
  cc_remove: "Kaldır",
  cc_remove_q: "Çalışan kaldırılsın mı?",
  cc_remove_text: "artık şirket adına rezervasyon yapamaz.",
  cc_removed: "Çalışan kaldırıldı.",
  cc_approvals_hint: "Limiti yetmeyen çalışanlar onay isteyebilir. Verilen onay tam bu rezervasyon için 14 gün geçerlidir.",
  cc_no_approvals: "Onay talebi yok.",
  cc_decision_note: "Not (isteğe bağlı)",
  cc_approve: "Onayla",
  cc_reject: "Reddet",
  cc_approved_done: "Onay verildi.",
  cc_rejected_done: "Talep reddedildi.",
  cc_ap_open: "açık",
  cc_ap_approved: "onaylandı",
  cc_ap_rejected: "reddedildi",
  cc_ap_used: "kullanıldı",
  cc_ap_expired: "süresi doldu",
  cc_valid_until: "geçerlilik:",
  cc_invite_off: "Bu özellik şu anda kullanılamıyor.",
  cc_invite_page_title: "Şirket daveti",
  cc_invite_page_text: "Şu şirket için transfer rezervasyonu yapmaya davet edildiniz:",
  cc_invite_for: "Davet edilen:",
  cc_invite_accept: "Daveti kabul et",
  cc_invite_wrong: "Başka bir adresle giriş yaptınız. Davet şu adres için:",
  cc_invite_no_account: "Hesabınız yok mu? Oluşturun",
  cc_invite_have_account: "Hesabınız var mı? Giriş yapın",
  cc_booking_for: "Rezervasyon:",
  cc_booking_for_desc: "Faturalı – şirketin çalışanı/yöneticisi olarak rezervasyon yapıyorsunuz.",
  cc_limit_left: "Yıllık limitten kalan",
  cc_passenger_hint: "Başka biri mi yolculuk edecek (ör. misafir)? Yolcuyu buraya girin – sürücü bu kişiyle iletişime geçer.",
  cc_passenger_name: "Yolcu adı (isteğe bağlı)",
  cc_passenger_phone: "Yolcu telefonu",
  cc_pick_billing: "Fatura adresi",
  cc_pick_billing_desc: "Fatura için şirket adresini seçin.",
  cc_payment_title: "Ödeme",
  cc_invoice_terms: "Ödeme vadesi",
  cc_approved_banner: "Şirketinizin onayı mevcut.",
  cc_limit_exceeded: "Bu rezervasyonla yıllık limitiniz aşılırdı.",
  cc_this_booking: "Bu rezervasyon",
  cc_approval_alt: "Alternatif olarak şirket yöneticilerinden onay isteyebilirsiniz:",
  cc_approval_note: "Yöneticiler için not (isteğe bağlı)",
  cc_approval_request: "Onay iste",
  cc_approval_sent: "Talep gönderildi. Onaydan sonra e-posta alacak ve rezervasyonu tamamlayabileceksiniz.",
  cc_book_invoice: "Faturalı rezervasyon yap",
};
const pl = {
  vehicleSearchPlaceholder: "Szukaj: tablica, marka, model …",
  gst_title: "Gość / pasażer",
  gst_desc: "Podróżuje ktoś inny? Podaj tu dane gościa.",
  gst_toggle: "Rezerwuję dla gościa (innej osoby)",
  gst_hint: "Kierowca skontaktuje się z gościem pod tymi danymi. Rezerwacja pozostaje na Twoim koncie i jest rozliczana przez Ciebie.",
  gst_optional: "opcjonalnie",
  gst_required: "Wymagane",
  gst_invalid: "nieprawidłowy",
  gst_email_hint: "Podając e-mail, gość otrzyma kopię potwierdzenia rezerwacji.",
  gst_missing: "Brakuje danych gościa",
  cc_pending_company_note: "Po potwierdzeniu wniosek firmowy dla „{name}” zostanie wysłany automatycznie.",
  invoice: "Na fakturę (nie pobierać)",
  cc_account_type: "Rodzaj konta",
  cc_private_person: "Osoba prywatna",
  cc_company: "Firma",
  cc_private: "Prywatnie",
  cc_switch: "Zmień konto",
  cc_pending: "w trakcie weryfikacji",
  cc_blocked: "zablokowana",
  cc_pending_hint: "GoTransfer24 nadal weryfikuje tę firmę.",
  cc_blocked_hint: "Ta firma jest zablokowana.",
  cc_register_company_hint: "Rejestrujesz się jako osoba kontaktowa firmy. Po potwierdzeniu e-maila jednym kliknięciem składasz wniosek firmowy; GoTransfer24 go sprawdza i aktywuje konto firmowe (do tego czasu rabat 0 %).",
  cc_company_name: "Nazwa firmy",
  cc_vat_id: "NIP UE (opcjonalnie)",
  cc_apply_open: "Złóż wniosek o konto firmowe",
  cc_apply_title: "Wniosek o konto firmowe",
  cc_apply_text: "GoTransfer24 sprawdzi wniosek i aktywuje firmę. Potem możesz zapraszać pracowników. Rezerwacje są rozliczane fakturą.",
  cc_apply_send: "Wyślij wniosek",
  cc_apply_done: "Wniosek wysłany. Otrzymasz e-mail po aktywacji firmy.",
  cc_contact_title: "Osoba kontaktowa firmy",
  cc_contact_hint: "Pracownicy widzą tę osobę, gdy limit nie wystarcza, i mogą się z nią skontaktować.",
  cc_no_limit: "Brak limitu",
  cc_admin_unlimited: "Jako administrator rezerwujesz bez limitu.",
  cc_my_limit: "Mój limit roczny",
  cc_used: "Wykorzystano",
  cc_remaining: "Pozostało",
  cc_limit_year: "Limit roczny",
  cc_limit_year_eur: "Limit roczny w €",
  cc_unlimited: "bez limitu",
  cc_member_blocked: "Twoje rezerwacje dla tej firmy zostały zablokowane.",
  cc_limit_contact: "W razie pytań lub podwyższenia",
  cc_limit_contact_ask: "Skontaktuj się z",
  cc_discount: "Rabat firmowy",
  cc_term: "Termin płatności",
  cc_days: "dni",
  cc_my_role: "Moja rola",
  cc_role: "Rola",
  cc_role_admin: "Administrator",
  cc_role_member: "Pracownik",
  cc_invoice_only: "Rezerwacje firmowe są rozliczane fakturą – bez płatności dla kierowcy.",
  cc_privacy_hint: "Informacja o prywatności: administrator firmy widzi wszystkie rezerwacje wykonane przez firmę (trasa, czas, cena, pasażer).",
  cc_tab_overview: "Przegląd",
  cc_tab_bookings: "Rezerwacje",
  cc_tab_members: "Pracownicy",
  cc_tab_addresses: "Adresy",
  cc_tab_approvals: "Zatwierdzenia",
  cc_cost_center: "Miejsce powstawania kosztów",
  cc_optional: "opcjonalnie",
  cc_cost_center_pick: "Wybierz miejsce kosztów",
  cc_cost_center_ph: "np. Sprzedaż lub projekt 4711",
  cc_cost_center_hint: "Pojawia się na fakturze zbiorczej i miesięcznym zestawieniu firmy.",
  cc_cost_centers_title: "Miejsca powstawania kosztów",
  cc_cost_centers_hint: "Jedno miejsce kosztów na wiersz. Pracownicy wybierają je przy rezerwacji; faktura i zestawienie są wg nich pogrupowane. Bez listy można wpisać dowolnie.",
  cc_cost_centers_ph: "Sprzedaż\\nZarząd\\nProjekt 4711",
  cc_cost_center_required: "Wymagaj miejsca kosztów przy każdej rezerwacji",
  cc_tab_invoices: "Faktury",
  cc_summary_title: "Zestawienie miesięczne",
  cc_summary_hint: "Wszystkie przejazdy miesiąca wg miejsca kosztów – PDF do sprawdzenia i przekazania.",
  cc_summary_show: "Pokaż zestawienie",
  cc_month: "Miesiąc",
  cc_no_trips_month: "W tym miesiącu nie ma zakończonych przejazdów.",
  cc_no_invoices: "Brak faktur.",
  cc_inv_open: "otwarta",
  cc_inv_paid: "zapłacona",
  cc_due: "termin",
  cc_download: "Pobierz",
  cc_close: "Zamknij",
  cc_tab_settings: "Kontakt i miejsca kosztów",
  cc_bookings_all: "Wszystkie rezerwacje firmy.",
  cc_bookings_own: "Twoje rezerwacje dla tej firmy.",
  cc_paid: "opłacone",
  cc_on_invoice: "Na fakturę",
  cc_passenger: "Pasażer",
  cc_booked_by: "zarezerwował(a)",
  cc_invite_title: "Zaproś pracownika",
  cc_invite_send: "Wyślij zaproszenie",
  cc_invited: "Zaproszenie wysłane.",
  cc_open_invites: "Oczekujące zaproszenia",
  cc_revoke: "Cofnij",
  cc_invite_revoked: "Zaproszenie cofnięte.",
  cc_you: "ty",
  cc_save_limit: "Zapisz limit",
  cc_saved: "Zapisano.",
  cc_block_booking: "Zablokuj rezerwowanie",
  cc_blocked_set: "Rezerwowanie zablokowane.",
  cc_blocked_unset: "Rezerwowanie ponownie dozwolone.",
  cc_remove: "Usuń",
  cc_remove_q: "Usunąć pracownika?",
  cc_remove_text: "nie będzie już mógł(-a) rezerwować dla firmy.",
  cc_removed: "Pracownik usunięty.",
  cc_approvals_hint: "Pracownicy, którym nie wystarcza limit, mogą poprosić o zatwierdzenie. Zatwierdzenie obowiązuje 14 dni dla tej rezerwacji.",
  cc_no_approvals: "Brak próśb o zatwierdzenie.",
  cc_decision_note: "Uwaga (opcjonalnie)",
  cc_approve: "Zatwierdź",
  cc_reject: "Odrzuć",
  cc_approved_done: "Zatwierdzono.",
  cc_rejected_done: "Prośbę odrzucono.",
  cc_ap_open: "otwarte",
  cc_ap_approved: "zatwierdzono",
  cc_ap_rejected: "odrzucono",
  cc_ap_used: "wykorzystano",
  cc_ap_expired: "wygasło",
  cc_valid_until: "ważne do",
  cc_invite_off: "Ta funkcja jest obecnie niedostępna.",
  cc_invite_page_title: "Zaproszenie do firmy",
  cc_invite_page_text: "Zaproszono Cię do rezerwowania transferów dla",
  cc_invite_for: "Zaproszenie dla",
  cc_invite_accept: "Przyjmij zaproszenie",
  cc_invite_wrong: "Jesteś zalogowany(-a) innym adresem. Zaproszenie dotyczy",
  cc_invite_no_account: "Nie masz konta? Utwórz",
  cc_invite_have_account: "Masz już konto? Zaloguj się",
  cc_booking_for: "Rezerwacja dla",
  cc_booking_for_desc: "Na fakturę – rezerwujesz jako pracownik/administrator firmy.",
  cc_limit_left: "Pozostało w limicie rocznym",
  cc_passenger_hint: "Podróżuje ktoś inny (np. gość)? Wpisz tu pasażera – kierowca skontaktuje się z tą osobą.",
  cc_passenger_name: "Imię i nazwisko pasażera (opcjonalnie)",
  cc_passenger_phone: "Telefon pasażera",
  cc_pick_billing: "Adres rozliczeniowy",
  cc_pick_billing_desc: "Wybierz adres firmy do faktury.",
  cc_payment_title: "Płatność",
  cc_invoice_terms: "Termin płatności",
  cc_approved_banner: "Firma zatwierdziła tę rezerwację.",
  cc_limit_exceeded: "Ta rezerwacja przekroczyłaby Twój limit roczny.",
  cc_this_booking: "Ta rezerwacja",
  cc_approval_alt: "Możesz też poprosić administratorów firmy o zatwierdzenie:",
  cc_approval_note: "Uwaga dla administratorów (opcjonalnie)",
  cc_approval_request: "Poproś o zatwierdzenie",
  cc_approval_sent: "Prośba wysłana. Po zatwierdzeniu dostaniesz e-mail i dokończysz rezerwację.",
  cc_book_invoice: "Zarezerwuj na fakturę",
};
const uk = {
  vehicleSearchPlaceholder: "Пошук: номер, марка, модель …",
  gst_title: "Гість / пасажир",
  gst_desc: "Їде хтось інший? Вкажіть дані гостя.",
  gst_toggle: "Я бронюю для гостя (іншої особи)",
  gst_hint: "Водій зв’яжеться з гостем за цими даними. Бронювання залишається у вашому акаунті й оплачується через вас.",
  gst_optional: "необов’язково",
  gst_required: "Обов’язково",
  gst_invalid: "недійсний",
  gst_email_hint: "З e-mail гість отримає копію підтвердження бронювання.",
  gst_missing: "Бракує даних гостя",
  cc_pending_company_note: "Після підтвердження заявку компанії «{name}» буде подано автоматично.",
  invoice: "За рахунком (не стягувати)",
  cc_account_type: "Тип акаунта",
  cc_private_person: "Приватна особа",
  cc_company: "Компанія",
  cc_private: "Приватно",
  cc_switch: "Змінити акаунт",
  cc_pending: "на перевірці",
  cc_blocked: "заблоковано",
  cc_pending_hint: "GoTransfer24 ще перевіряє цю компанію.",
  cc_blocked_hint: "Цю компанію заблоковано.",
  cc_register_company_hint: "Ви реєструєтеся як контактна особа компанії. Після підтвердження e-mail одним кліком подаєте заявку; GoTransfer24 перевіряє її та активує акаунт компанії (до того знижка 0 %).",
  cc_company_name: "Назва компанії",
  cc_vat_id: "ІПН ПДВ (необов’язково)",
  cc_apply_open: "Подати заявку на акаунт компанії",
  cc_apply_title: "Заявка на акаунт компанії",
  cc_apply_text: "GoTransfer24 перевіряє заявку та активує компанію. Потім можна запрошувати співробітників. Бронювання оплачуються за рахунком.",
  cc_apply_send: "Надіслати заявку",
  cc_apply_done: "Заявку надіслано. Ви отримаєте e-mail після активації компанії.",
  cc_contact_title: "Контактна особа компанії",
  cc_contact_hint: "Співробітники бачать цю особу, коли ліміту не вистачає, і можуть звернутися до неї.",
  cc_no_limit: "Без ліміту",
  cc_admin_unlimited: "Як адміністратор ви бронюєте без ліміту.",
  cc_my_limit: "Мій річний ліміт",
  cc_used: "Використано",
  cc_remaining: "Залишилось",
  cc_limit_year: "Річний ліміт",
  cc_limit_year_eur: "Річний ліміт у €",
  cc_unlimited: "без обмежень",
  cc_member_blocked: "Ваші бронювання для цієї компанії заблоковано.",
  cc_limit_contact: "З питань або для підвищення",
  cc_limit_contact_ask: "Зверніться до",
  cc_discount: "Знижка компанії",
  cc_term: "Строк оплати",
  cc_days: "днів",
  cc_my_role: "Моя роль",
  cc_role: "Роль",
  cc_role_admin: "Адміністратор",
  cc_role_member: "Співробітник",
  cc_invoice_only: "Бронювання компанії оплачуються за рахунком – без оплати водієві.",
  cc_privacy_hint: "Конфіденційність: адміністратор вашої компанії бачить усі бронювання через компанію (маршрут, час, ціна, пасажир).",
  cc_tab_overview: "Огляд",
  cc_tab_bookings: "Бронювання",
  cc_tab_members: "Співробітники",
  cc_tab_addresses: "Адреси",
  cc_tab_approvals: "Погодження",
  cc_cost_center: "Центр витрат",
  cc_optional: "необов'язково",
  cc_cost_center_pick: "Оберіть центр витрат",
  cc_cost_center_ph: "напр. Продажі або проєкт 4711",
  cc_cost_center_hint: "Відображається у зведеному рахунку та місячному огляді вашої компанії.",
  cc_cost_centers_title: "Центри витрат",
  cc_cost_centers_hint: "Один центр витрат на рядок. Працівники обирають його під час бронювання; рахунок і огляд групуються за ним. Без списку можна вписати вільно.",
  cc_cost_centers_ph: "Продажі\\nКерівництво\\nПроєкт 4711",
  cc_cost_center_required: "Вимагати центр витрат для кожного бронювання",
  cc_tab_invoices: "Рахунки",
  cc_summary_title: "Місячний огляд",
  cc_summary_hint: "Усі поїздки місяця за центрами витрат – PDF для перевірки та передачі.",
  cc_summary_show: "Показати огляд",
  cc_month: "Місяць",
  cc_no_trips_month: "У цьому місяці немає завершених поїздок.",
  cc_no_invoices: "Рахунків ще немає.",
  cc_inv_open: "відкритий",
  cc_inv_paid: "оплачено",
  cc_due: "до",
  cc_download: "Завантажити",
  cc_close: "Закрити",
  cc_tab_settings: "Контакт і центри витрат",
  cc_bookings_all: "Усі бронювання компанії.",
  cc_bookings_own: "Ваші бронювання для цієї компанії.",
  cc_paid: "сплачено",
  cc_on_invoice: "За рахунком",
  cc_passenger: "Пасажир",
  cc_booked_by: "забронював(ла)",
  cc_invite_title: "Запросити співробітника",
  cc_invite_send: "Надіслати запрошення",
  cc_invited: "Запрошення надіслано.",
  cc_open_invites: "Відкриті запрошення",
  cc_revoke: "Скасувати",
  cc_invite_revoked: "Запрошення скасовано.",
  cc_you: "ви",
  cc_save_limit: "Зберегти ліміт",
  cc_saved: "Збережено.",
  cc_block_booking: "Заблокувати бронювання",
  cc_blocked_set: "Бронювання заблоковано.",
  cc_blocked_unset: "Бронювання знову дозволено.",
  cc_remove: "Видалити",
  cc_remove_q: "Видалити співробітника?",
  cc_remove_text: "більше не зможе бронювати для компанії.",
  cc_removed: "Співробітника видалено.",
  cc_approvals_hint: "Співробітники, яким не вистачає ліміту, можуть запросити погодження. Надане погодження діє 14 днів для цього бронювання.",
  cc_no_approvals: "Запитів на погодження немає.",
  cc_decision_note: "Примітка (необов’язково)",
  cc_approve: "Погодити",
  cc_reject: "Відхилити",
  cc_approved_done: "Погодження надано.",
  cc_rejected_done: "Запит відхилено.",
  cc_ap_open: "відкрито",
  cc_ap_approved: "погоджено",
  cc_ap_rejected: "відхилено",
  cc_ap_used: "використано",
  cc_ap_expired: "прострочено",
  cc_valid_until: "дійсно до",
  cc_invite_off: "Ця функція наразі недоступна.",
  cc_invite_page_title: "Запрошення до компанії",
  cc_invite_page_text: "Вас запросили бронювати трансфери для",
  cc_invite_for: "Запрошення для",
  cc_invite_accept: "Прийняти запрошення",
  cc_invite_wrong: "Ви увійшли з іншою адресою. Запрошення для",
  cc_invite_no_account: "Немає акаунта? Створити",
  cc_invite_have_account: "Вже є акаунт? Увійти",
  cc_booking_for: "Бронювання для",
  cc_booking_for_desc: "За рахунком – ви бронюєте як співробітник/адмін компанії.",
  cc_limit_left: "Залишок річного ліміту",
  cc_passenger_hint: "Їде хтось інший (напр. гість)? Вкажіть пасажира – водій зв’яжеться з ним.",
  cc_passenger_name: "Ім’я пасажира (необов’язково)",
  cc_passenger_phone: "Телефон пасажира",
  cc_pick_billing: "Адреса для рахунку",
  cc_pick_billing_desc: "Оберіть адресу компанії для рахунку.",
  cc_payment_title: "Оплата",
  cc_invoice_terms: "Строк оплати",
  cc_approved_banner: "Компанія погодила це бронювання.",
  cc_limit_exceeded: "Ця бронь перевищила б ваш річний ліміт.",
  cc_this_booking: "Це бронювання",
  cc_approval_alt: "Або запросіть погодження в адміністраторів компанії:",
  cc_approval_note: "Примітка для адмінів (необов’язково)",
  cc_approval_request: "Запросити погодження",
  cc_approval_sent: "Запит надіслано. Після погодження ви отримаєте e-mail і зможете завершити бронювання.",
  cc_book_invoice: "Забронювати за рахунком",
};
export default { de, en, tr, pl, uk };
